import * as ActionConfigurationManager from './config.actions';

export const account = ActionConfigurationManager.HAPPY_PATH
export const guest = ActionConfigurationManager.NIS
export const edit = ActionConfigurationManager.EDIT
export const editAccount = ActionConfigurationManager.EDIT_ACCOUNT
export const serviceDrive = ActionConfigurationManager.SERVICE_DRIVE
export const serviceDriveAbandonedCart  = ActionConfigurationManager.SERVICE_DRIVE_ABANDONED_CART
export const sdLogout = ActionConfigurationManager.SD_LOGOUT